import { BaseModel, Guid, RecursivePartial } from "@models/base";
import { CodeSnippet } from '@models/shared/code-snippet';

export class ChatMessageDraft extends BaseModel {
    threadId?: Guid;
    replyId?: Guid;
    richText?: { [key: string]: any };
    fileIds?: Guid[];
    snippets?: CodeSnippet[];

    constructor(json?: RecursivePartial<ChatMessageDraft>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<ChatMessageDraft>): ChatMessageDraft {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<ChatMessageDraft>): void {
        ChatMessageDraft.assignFields<ChatMessageDraft>(this, json, ['threadId', 'replyId', 'richText', 'fileIds']);
        ChatMessageDraft.assignClassArrays<ChatMessageDraft>(this, json, { snippets: CodeSnippet });
    }
}
